<template>
  <div class="pr">
    <div class="pr box">
      <template >
        <div class="bright-tag" @click.stop="inputFunc()">
          <template>
            <div v-for="(item, index) in showList" :key="index" class="input-item fl f_14 color_40 bg_f9">
              {{item}}<span class="iconfont iconguanbi color_cf pr" @click.stop="handleClickAddOrDelete(item)"></span>
            </div>
          </template>
          <input placeholder="请选择或输入职位亮点" v-model="customTagText" @keyup.enter="handleClickCustomTag"/>
        </div>
        <div class="tags-box" @click.stop v-show="show && !customTagText && jobBrightSpotVisible">
          <template>
            <div v-for="(item, index) in customTagList" :key="index + 'a'" class="tag-item" :class="{'active': showList.includes(item)}" @click.stop="handleClickAddOrDelete(item)">{{item}}</div>
            <div v-for="(item, index) in list" :key="index" class="tag-item" :class="{'active': showList.includes(item)}" @click.stop="handleClickAddOrDelete(item)">{{item}}</div>
          </template>
        </div>
        <div class="custom-tags-box" @click.stop v-show="show && customTagText && jobBrightSpotVisible">
          <template v-if="!customTagText">
            <div v-for="(item, index) in list" :key="index" class="tag-item" :class="{'active': showList.includes(item)}" @click.stop="handleClickAddOrDelete(item)">{{item}}</div>
          </template>
          <template v-else>
            <div v-if="list.filter(item=>item.includes(customTagText)).length === 0" class="tag-item color_9c flex" @click="handleClickCustomTag">
              <span class="flex1">{{customTagText}}</span>
              <span class="color_9c">回车添加标签</span>
            </div>
            <div class="tag-item" v-for="(item, index) in list.filter(item=>item.includes(customTagText))" :key="index" @click.stop="handleClickAddOrDelete(item, true)">
              <p class="f_14 color_9c flex1" >{{item}}</p>
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'

  export default {
    name: "brightTags",
    props:['value', 'type', 'jobBrightSpotVisible'],
    data(){
      return{
        show: false,
        list: ['不打卡', '免费健身房', '下午茶', '弹性工作', '地铁周边', '提供早午饭', '周末双休', '房补', '餐补', '生日福利', '定期团建', '全勤奖', '朝九晚五', '大牛导师', '扁平化管理', '有独立项目机会', '业务核心', '成长迅速', '业务owner', '创新业务', '技术前沿'],
        showList:[],
        internshipList: ['远程实习', '可转正实习', '暑期实习', '寒假实习', '日常实习', '接受大一大二'],
        customTagText: '',
        customTagList: []
      }
    },
    mounted() {
      document.addEventListener('click',()=>{
        this.show = false
      })
    },
    methods:{
      ...mapMutations('jobEdit', ['updateSelectTagsState', 'updateSearchTagsState','updateJobTags','updateUserCheckTags','updateUserAddTags']),

      inputFunc () {
        this.$emit('jobBrightSpot', !this.show)
        this.show = !this.show
      },
      handleClickAddOrDelete(item, bool){
        if(bool){
          this.customTagText = ''
        }
        if(!this.showList.includes(item)){
          if(this.showList.length === 8){
            this.$message({
              message: '职位亮点最多选择8个',
              type: 'warning'
            });
            return
          }
          this.showList.push(item)
        }else{
          this.showList = this.showList.filter(text=> text!=item)
        }
        this.$emit("updateList", this.showList)
      },
      handleClickCustomTag(){
        this.customTagList.push(this.customTagText)
        this.showList.push(this.customTagText)
        this.customTagText = ''
      }
    },
    watch:{
      value:{
        immediate: true,
        handler(val){
          this.showList = val
          this.customTagList = this.showList.filter(item => !this.list.includes(item))
        }
      },
      type:{
        immediate: true,
        handler(val, old){
          // console.log("初始化type",val)
          if(val === '全职'){
            this.list = ['不打卡', '免费健身房', '下午茶', '弹性工作', '地铁周边', '提供早午饭', '周末双休', '房补', '餐补', '生日福利', '定期团建', '全勤奖', '朝九晚五', '大牛导师', '扁平化管理', '有独立项目机会', '业务核心', '成长迅速', '业务owner', '创新业务', '技术前沿']
          }else if(val ==='实习'){
            this.list = [...this.internshipList, '不打卡', '免费健身房', '下午茶', '弹性工作', '地铁周边', '提供早午饭', '周末双休', '房补', '餐补', '生日福利', '定期团建', '全勤奖', '朝九晚五', '大牛导师', '扁平化管理', '有独立项目机会', '业务核心', '成长迅速', '业务owner', '创新业务', '技术前沿']
          }
          if(old === '实习' && val === '全职'){
            this.showList = this.showList.filter(item => !this.internshipList.includes(item))
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.bright-tag{
  border: 1px solid #ECECEC;
  line-height: 40px;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 0 15px;
  min-height: 42px;
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  & >.placeholder{
    color: #BCBCBC;
  }
  .input-item{
      padding: 0 10px 0 12px;
      line-height: 28px;
      height: 28px;
      white-space:nowrap;
      border-radius: 14px;
      margin: 6px 8px 6px 0;
      .iconfont{
        font-size: 12px;
        margin-left: 6px;
        padding: 0 2px;
        z-index: 2;
        &:hover{
          color: #606060;
        }
      }
  }
}
.tags-box{
  width: 480px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(156, 156, 156, 0.2);
  border-radius: 2px;
  margin-top: 4px;
  padding: 16px 12px;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  position: absolute;
  top: 100%;
  z-index: 9;
  .tag-item{
    margin-right: 16px;
    margin-bottom: 16px;
    padding: 4px 12px;
    border: 1px solid #CFCFCF;
    box-sizing: border-box;
    text-align: center;
    color: #9C9C9C;
    font-size: 14px;
    border-radius: 16px;
    cursor: pointer;
    &.active{
      background-color: #4183FF;
      color: #FFFFFF;
      border: 1px solid #4183FF;
    }
  }
}
  .custom-tags-box{
    width: 480px;
    background: #FFFFFF;
    box-shadow: 0px 4px 10px 0px rgba(156, 156, 156, 0.2);
    border-radius: 2px;
    margin-top: 4px;
    box-sizing: border-box;
    max-height:236px;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 10px 0;
    position: absolute;
    z-index: 9;
    top: 100%;
    .tag-item{
      padding: 10px 16px;
      line-height: 20px;
      cursor: pointer;
      &:hover{
        .flex1{
          color: #4183FF;
        }
      }
    }
  }
</style>
